<template>
  <div class="w-full flex justify-center items-center relative">
    <div
      class="text-center w-full relative z-20 text-black bg-white flex flex-col items-center justify-center space-y-6"
    >
      <h3>Hootmail Updates Required!</h3>
      <p>
        An update has been released that requires you to run an update through
        hootmail. You will be locked out of certain parts of the admin area
        until the update has been completed.
      </p>

      <button class="btn btn-primary mt-8" @click="goToHootmail">
        Take me to Hootmail
      </button>
    </div>
  </div>
</template>

<script>
import { shared } from '../../../../js/mixins/shared.js'
import { EventBus } from '../../../../js/plugins/event-bus.js'

export default {
  mixins: [shared],

  methods: {
    goToHootmail() {
      this.$router.push({ path: '/manager/hootmail' })
      EventBus.$emit('showModal', '')
    },
  },
}
</script>
